"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useForceUpdate() {
    var _a = react_1.useState({}), updateComponent = _a[1];
    return react_1.useCallback(function () {
        updateComponent({});
    }, []);
}
exports.useForceUpdate = useForceUpdate;
function removeArrayElement(arr, elem) {
    var index = arr.indexOf(elem);
    if (index === -1) {
        return;
    }
    arr.splice(index, 1);
}
exports.removeArrayElement = removeArrayElement;
